import { gql } from "lib/apolloClient";
import {
  studentsAlertFragment,
  userNameFragment,
} from "modules/CommonFragments";

export const studentItemFragment = gql`
  fragment studentItem on Student {
    ...userNameFields
    profileImage
    alertTypes {
      ...alertTypeFields
    }
    courses {
      id
      title
      grades {
        id
        name
      }
    }
    studentGoalsV2 {
      totalCount
      count {
        ongoing
        completed
      }
    }
  }
  ${studentsAlertFragment}
  ${userNameFragment}
`;

export const getStudentByCourseIdsQuery = gql`
  query getStudentByCourseIds(
    $id: ID!
    $filters: OrgConnectionFilterInput
    $after: String
    $orderBy: ORDER_BY_ENUM
    $studentCurriculumProgramFilters: StudentCurriculumProgramFilter
  ) {
    node(id: $id, type: ORGANIZATION) {
      ... on Organization {
        id
        students(
          first: 20
          filters: $filters
          after: $after
          orderBy: $orderBy
        ) {
          totalCount
          pageInfo {
            hasNextPage
            startCursor
            endCursor
          }
          edges {
            node {
              ...studentItem
              curriculumPrograms(filters: $studentCurriculumProgramFilters) {
                id
                acronym
              }
            }
          }
        }
      }
    }
  }
  ${studentItemFragment}
`;
